"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Email = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _noop = _interopRequireDefault(require("lodash/noop"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
var _default = exports["default"] = function _default(_ref) {
  var children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4"
  }, _react["default"].Children.count(children) > 0 ? children : /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
    src: t('placeholder-email.png'),
    text: t('contact.detail.email.empty')
  }));
};
var Email = exports.Email = function Email(_ref2) {
  var subject = _ref2.subject,
    date = _ref2.date,
    snippet = _ref2.snippet,
    onClick = _ref2.onClick,
    isActive = _ref2.isActive;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('p-4 h-20 hover:bg-secondary cursor-pointer', {
      'bg-secondary': isActive
    }),
    onClick: isActive ? _noop["default"] : onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink pr-4 text-sm font-bold truncate text-dark"
  }, subject), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-none text-xs font-semibold text-dark"
  }, date)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm font-light leading-loose truncate text-medium"
  }, snippet));
};
//# sourceMappingURL=EmailsView.js.map